





































import {
  Component, Prop, PropSync, Vue,
} from 'vue-property-decorator';
import {
  DocumentRequest, FilesApi, Document,
} from '@compassdigital/foodworks.ts.sdk';
import UserModule from '@/store/modules/user';
import Format from '@/util/Format';

@Component({
  components: {
  },
})

export default class RestaurantAuditForm extends Vue {
  @PropSync('documents', {}) document!: any;

  @Prop({}) saving!: boolean;

  @Prop({ default: true }) showDeleteIcon!: boolean;

  get DocumentFiles() {
    if (this.document) {
      return this.document;
    }
    return null;
  }

  public getDocumentDate(uploadDate: any) {
    return Format.getFomattedDate(uploadDate);
  }

  public deleteDoc(document: Document) {
    this.$emit('onDeleteDoc', document);
  }

  public onDownload(url: string) {
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    // Set the HREF to a Blob representation of the data to be downloaded
    a.href = url;
    a.setAttribute('download', '');
    a.setAttribute('target', '_blank');

    // Use download attribute to set set desired file name
    // Trigger the download by simulating click
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }

  get onBoardingPartner() {
    if (UserModule.currentUser && UserModule.currentRole === 'partner_owner') {
      return UserModule.currentUser.id;
    }
    return '';
  }
}

